module.exports = __webpack_public_path__ + "static/media/keyboard.ae635de8.mp4";